{
  "title": "Virtual Machines",
  "subtitle": "QEMU/KVM — bridged networking, VNC in browser, snapshots.",
  "new_vm": "New VM",
  "refresh": "Refresh",
  "loading": "Loading…",
  "empty": "No VMs yet. Click",
  "empty_cta": "\"New VM\"",
  "empty_suffix": "to get started.",
  "tip": "Tip:",
  "tip_iso": "upload an ISO via the ISO Library first, then create a VM with that ISO.",
  "summary": {
    "total": "Total VMs",
    "running": "Running",
    "vcpu": "vCPU used",
    "ram": "RAM used"
  },
  "status": {
    "created": "Created",
    "starting": "Starting…",
    "running": "Running",
    "stopping": "Stopping…",
    "stopped": "Stopped",
    "error": "Error"
  },
  "actions": {
    "start": "Start",
    "console": "Console",
    "stop": "Stop",
    "poweroff": "Off",
    "console_title": "Open VNC console in browser",
    "stop_title": "Graceful shutdown (ACPI)",
    "poweroff_title": "Hard power-off (SIGKILL)",
    "logs_title": "QEMU log",
    "snapshots_title": "Snapshots",
    "edit_title": "Edit VM",
    "delete_title": "Delete"
  },
  "iso": {
    "title": "ISO Library",
    "close": "Close",
    "empty": "No ISOs available.",
    "upload": "Upload ISO",
    "uploading": "Upload {{pct}}%"
  },
  "imports": {
    "title": "Disk Import",
    "button": "Disk Import",
    "empty": "No import jobs.",
    "upload": "Upload disk image (qcow2/raw/vmdk/vdi)",
    "uploading": "Upload {{pct}}%",
    "server_path_placeholder": "Server path to existing disk (admin only, e.g. /tmp/disk.qcow2)",
    "delete_confirm": "Delete job \"{{id}}…\"?",
    "delete_confirm_done": " (qcow2 will also be deleted if not used by a VM)"
  },
  "snapshots": {
    "loading": "Loading…",
    "empty": "No snapshots yet.",
    "name_placeholder": "Snapshot name (e.g. before-update)",
    "desc_placeholder": "Description (optional)",
    "error_name_empty": "Name must not be empty"
  },
  "logs": {
    "no_log": "No log file yet — VM has not been started.",
    "empty": "Log is empty."
  },
  "create": {
    "title": "Create new VM",
    "submit": "Create VM",
    "submitting": "Creating…",
    "cancel": "Cancel",
    "error_name_invalid": "Name: 1–32 chars, starts with letter, only a-z A-Z 0-9 -",
    "field_node": "Target node",
    "node_hint": "Defaults to the local QEMU host. Remote nodes need Incus + KVM.",
    "node_local": "Local (QEMU)",
    "field_image": "Image",
    "image_hint": "Curated cloud image for the remote VM.",
    "remote_note": "Remote VM: runs permanently as an Incus VM on the selected node (admin-only). ISO boot, import and passthrough are unavailable on remote nodes.",
    "field_name": "Name",
    "field_name_hint": "1–32 chars, starts with letter, only a-z A-Z 0-9 -",
    "field_desc": "Description (optional)",
    "field_boot_src": "Boot source",
    "field_iso": "Select ISO",
    "field_import_job": "Select import job",
    "field_import_hint": "qcow2 will be moved into the VM; the job disappears after.",
    "field_network": "Network",
    "field_disk_interface": "Disk interface",
    "field_machine_type": "Machine type",
    "field_network_device": "Network device",
    "no_isos": "No ISOs available — upload one first.",
    "disk_size_from_import": "Disk size comes from the imported file.",
    "boot_iso_title": "Boot from ISO",
    "boot_iso_desc": "New disk + ISO as boot medium",
    "boot_import_title": "Imported disk",
    "boot_import_desc": "Use qcow2 from import job",
    "boot_blank_title": "Blank disk",
    "boot_blank_desc": "Boot loop until setup is provided",
    "net_bridged_title": "Bridged (br0)",
    "net_bridged_desc": "VM gets DHCP IP from LAN",
    "net_isolated_title": "Isolated",
    "net_isolated_desc": "No network access",
    "disk_hint_iso": "virtio = fastest performance under KVM. sata when guest OS lacks virtio drivers (e.g. Windows without virtio-win).",
    "disk_hint_import": "sata = compatible with most imported images. virtio if the source includes virtio drivers.",
    "disk_virtio_title": "virtio",
    "disk_virtio_desc": "Fast, default",
    "disk_sata_desc": "Compatible, for imported images",
    "disk_ide_desc": "Legacy, last resort",
    "machine_hint": "q35 = modern ICH9 chipset (default). pc = i440FX, compatible with FreeBSD ZFS boot, Windows XP, old Linux, VirtualBox imports.",
    "machine_q35_desc": "Modern, default",
    "machine_pc_desc": "Compatible, FreeBSD/XP/legacy",
    "netdev_hint": "virtio-net-pci = fast (default). e1000 = Intel NIC, supported in almost every guest OS — for imports without virtio drivers.",
    "netdev_virtio_desc": "Fast, default",
    "netdev_e1000_desc": "Intel driver, compatible"
  },
  "edit": {
    "error_name_invalid": "Name: 1-32 chars, starts with letter, only a-z A-Z 0-9 -",
    "error": "Error",
    "field_name": "Name",
    "field_desc": "Description",
    "field_cpu": "CPU cores",
    "field_ram": "RAM (MB)",
    "field_boot_iso": "Boot ISO (empty = no ISO inserted)",
    "field_disk_interface": "Disk interface",
    "field_machine_type": "Machine type",
    "field_network_device": "Network device",
    "disk_virtio_label": "virtio (fast, default)",
    "disk_sata_label": "sata (compatible, for imported images)",
    "disk_ide_label": "ide (legacy)"
  }
}
